module.exports = __webpack_public_path__ + "img/lowcode-3.f7dbc127.png";